// @givmo/app-charity — the catalog-removal request page's route path (CPA-WEB7; re-addressed to
// `/removal` and retitled "Remove from Givmo" at Org Machinery OM-17's cut-over, RULED 2026-09-07).
//
// Single source of truth for the removal page's address so the route tree (routes.tsx), the console's
// page declarations (console/console-nav.ts), the composed settings page's removal card (its DOOR)
// and the preview harness all agree — none of them spells the literal. Kept as a plain string
// constant (not a TanStack route object) to avoid an import cycle with the route tree — mirrors
// PROFILE/PAYMENT_ROUTES.
//
// ⚠ This page no longer answers `/settings`: that word and that address belong to the console's ONE
// composed settings page (`console/console-routes.ts`); this page answers `/removal` only.

export const SETTINGS_ROUTES = {
  /** The request-to-be-removed flow — the page titled "Remove from Givmo". */
  removal: '/removal',
} as const;
